module.exports = __webpack_public_path__ + "71da005548dd4a47dbca2c369fa51748.png";